body.turbodebug {
  turbo-frame.turbodebug {
    border: 1px dashed red;
    display: block;

    &::before {
      content: "Frame #" attr(id) " " attr(src);
      position: absolute;
      font-size: 0.75rem;
      color: red;
      pointer-events: none;
      z-index: 9999;
      top: 0.25rem;
      left: 0.25rem;
      background: rgba(255, 255, 255, 0.7);
      padding: 0 2px;
      white-space: nowrap;
    }
  }
}
